// figure out what set of credentials to return
if (process.env.NODE_ENV === 'production') {
  // return prod set of keys
  module.exports = require('./ConfigProd')
} else {
  // return the dev keys
  module.exports = require('./ConfigLocal')
}
